import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import Locales from "./locales";

const feature = "locales";

const InitialState = Record({
  locales: new Locales()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function LocalesReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  switch (action.type) {
    case actions.GET_LOCALES: {
      return state.setIn(["locales", "loading"], true);
    }
    case actions.GET_LOCALES_SUCCESS: {
      state = state.setIn(
        ["locales", "defaultLocale"],
        action.payload.defaultLocale
      );
      state = state.setIn(["locales", "locales"], action.payload.locales);
      return state.setIn(["locales", "loading"], false);
    }
    case actions.GET_LOCALES_ERROR: {
      return state.setIn(["locales", "loading"], false);
    }

  }

  return entitiesReducer(state, feature, action);
}



// WEBPACK FOOTER //
// ./src/common/locales/reducer.js